import { Alert, Link } from "@mui/material";
import type { Message } from "./types";

export function MessagePreview({ message }: { message: Pick<Message, "type" | "text" | "linkUrl"> }) {
	const safeLink = message.linkUrl && /^https?:\/\//i.test(message.linkUrl) ? message.linkUrl : undefined;
	return (
		<Alert
			severity={message.type === "Outage" ? "warning" : "info"}
			sx={{
				borderRadius: 0,
				width: "100%",
				boxSizing: "border-box",
				fontWeight: 600,
				backgroundColor: message.type === "Outage" ? "#fff4e5" : "#e2f7fc",
				color: message.type === "Outage" ? "#7a4700" : "#006c90",
				"& .MuiAlert-message": { overflowWrap: "anywhere", whiteSpace: "pre-wrap", minWidth: 0 }
			}}
		>
			{safeLink ? (
				<Link
					variant="inherit"
					underline="hover"
					href={safeLink}
					target="_blank"
					rel="noopener noreferrer"
					color="inherit"
					fontWeight="inherit"
				>
					{message.text || "Message preview"}
				</Link>
			) : (
				message.text || "Message preview"
			)}
		</Alert>
	);
}
